
































import useNavigationV2 from "@/shared/composition/useNavigationV2";
import tablaVue from "../lista/tabla.vue";
import useContenido from "./useContenido";

import {
  defineComponent,
  onMounted,
  ref,
  toRefs,
  watch,
} from "@vue/composition-api";

export default defineComponent({
  props: {
    titulo: String,
    campos: Array,
    get: Object,
    nuevo: Object,
    seleccion: Object,
    query: Object,
    dialogData: Object
  },
  components: {
    tabla: tablaVue,
  },
  setup(props, { emit, root }) {
    const { get, nuevo, query, campos, dialogData } = toRefs(props);

    const {
      cargando,
      items,
      cargarDataTest
    } = useContenido(get, campos);

    const cargar = async () => {
      cargando.value = true;
 
      await cargarDataTest(query.value)
    };

    onMounted(() => {
      console.log("mounted");
      cargar();
    });

    watch([get, query, dialogData], cargar);

    const vistas = [
      // {
      //   titulo: "Vista compacta",
      //   nombre: "test",
      // },
      // {
      //   titulo: "Tabla",
      //   nombre: "tabla",
      // },
    ];

    const navegar = (config, query = {}) => {
      const { goTo } = useNavigationV2(config);
      // goTo(seleccion);
      emit("abrir", { config, query })
    };

    const abrirNuevo = () => {
      const { goTo } = useNavigationV2(nuevo.value);
      // goTo(query.value);
      emit("abrir", { config: nuevo.value, query: query.value })
    };

    return {
      vista: "tabla",
      vistas,
      items,
      cargando,
      navegar,
      abrirNuevo,
    };
  },
});
